// extracted by mini-css-extract-plugin
export default {"container":"styles_container__wAoDf","opportunitiesLabel":"styles_opportunitiesLabel__dy-39","opportunitiesCount":"styles_opportunitiesCount__mD4HH","beta":"styles_beta__76tzw"};